import React, { useRef, useEffect, useCallback, useState} from 'react';
import ExpandedProject from './ExpandedProject.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import ProjectOption from './ProjectOption.js';
import {useScroll} from 'components/selector2/useScroll.js';
import {connect} from 'react-redux';
import {getProjects} from './getProjects.js';

const SequencesList = ({
    guildId,
    sequencerEngine,
    searchTerm,
    filterMine,
    setExpandedProject,
    expandedProject,
    starred,
    favorited
}) => { 
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef(undefined);
    let {size} = useScroll(ref, 24, true, searchTerm, expandedProject);

    useEffect(() => {
        if (expandedProject) {
            return;
        }
        setIsLoading(true);
        getProjects(searchTerm, filterMine, starred, favorited, undefined, undefined, guildId).then(
            x => {
                setIsLoading(false);
                setResults(x);
            });
    }, [searchTerm, setResults, filterMine, setIsLoading, expandedProject, starred, favorited, guildId]);
    let style = {
        height: window.innerHeight - 216
    };
    return (
        <div ref={ref} style={style} className="sequences-list">
          {isLoading ? 
           <UnknownProgressBar text="Loading Projects"/> : 
           expandedProject ?
           <div className="project-and-back">
             <div
               onClick={() => setExpandedProject(undefined)}
               className="selector-back-button"/>
             <ProjectOption
               setExpandedProject={setExpandedProject}
               sequencerEngine={sequencerEngine}
               project={expandedProject}
               expanded={true}/>
           </div>
           : results.slice(0, size).map(
               (x,i) =>
                   <ProjectOption
                     key={i + '-' + x.newSequence}
                     setExpandedProject={setExpandedProject}
                     sequencerEngine={sequencerEngine}
                     project={x}/>)}
          {expandedProject ?
           <ExpandedProject project={expandedProject} sequencerEngine={sequencerEngine}/> :
           ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencesList);
